/**
 * `PdfBrush` class provides objects used to fill the interiors of graphical shapes such as rectangles,
 * ellipses, pies, polygons, and paths.
 * @private
 */
var PdfBrush = /** @class */ (function () {
    /**
     * Creates instanceof `PdfBrush` class.
     * @hidden
     * @private
     */
    function PdfBrush() {
        //
    }
    //IClonable implementation
    PdfBrush.prototype.clone = function () {
        return this;
    };
    return PdfBrush;
}());
export { PdfBrush };



//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/node_modules/@syncfusion/ej2-angular-pdfviewer/node_modules/@syncfusion/ej2-pdf-export/src/implementation/graphics/brushes/pdf-brush.js
// module id = ../../../../@syncfusion/ej2-angular-pdfviewer/node_modules/@syncfusion/ej2-pdf-export/src/implementation/graphics/brushes/pdf-brush.js
// module chunks = vendor